import * as yup from 'yup';

// Validation schema factory for creating internal contacts
// Validates that selected roles exist in the available roles list
export const internalOrderContactsForm = (validRoles: string[]) =>
  yup.object({
      adminId: yup.string().nullable().required('Admin is required'),
      roles: yup
        .array()
        .of(yup.string().oneOf(validRoles, 'Invalid role selected'))
        .min(1, 'At least one role is required')
        .nullable()
        .required('Roles are required'),
    phoneExtension: yup.number().min(1).max(999).nullable(),
    timeZone: yup.string().nullable(),
    notes: yup.string().nullable(),
  });

// Validation schema factory for editing internal contacts
// Validates that selected roles exist in the available roles list
export const editInternalOrderContactsForm = (validRoles: string[]) =>
  yup.object({
      id: yup.string().nullable().required('Contact ID is required'),
      roles: yup
        .array()
        .of(yup.string().oneOf(validRoles, 'Invalid role selected'))
        .min(1, 'At least one role is required')
        .nullable()
        .required('Roles are required'),
    phoneExtension: yup.number().min(1).max(999).nullable(),
    timeZone: yup.string().nullable(),
    notes: yup.string().nullable(),
  });
